import { useRef, useState } from "react";
import { Maximize2, Minimize2, Volume2, VolumeX } from "lucide-react";

export const HeroVideo = ({ src, poster, fill = false, onPlaying }) => {
  const ref = useRef(null);
  const [muted, setMuted] = useState(true);
  const [zoomed, setZoomed] = useState(false);
  // Logo sits ~3.6% left of centre in the footage; nudge right and enlarge on upright phones
  const fit = zoomed
    ? "object-cover portrait:object-[45%_50%]"
    : "object-contain portrait:translate-x-[4.25%] portrait:scale-[1.18] landscape:object-cover";

  const toggle = () => {
    const v = ref.current;
    v.muted = !v.muted;
    if (!v.muted) v.play().catch(() => {});
    setMuted(v.muted);
  };

  return (
    <section className={`overflow-hidden bg-black ${fill ? "absolute inset-0" : "relative"}`} data-testid="home-hero">
      <video ref={ref} data-testid="hero-video" src={src} poster={poster} autoPlay loop muted playsInline onPlaying={onPlaying}
        className={fill ? `absolute inset-0 w-full h-full ${fit}` : "block w-full h-auto"} />
      {!fill && <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#0a0b0e] to-transparent pointer-events-none" />}
      <button onClick={toggle} data-testid="hero-sound-toggle" aria-label={muted ? "Turn sound on" : "Turn sound off"}
        className={`absolute right-4 sm:right-8 z-10 rounded-full bg-black/60 backdrop-blur border border-[#00d436]/50 text-lime flex items-center justify-center hover:bg-[#00d436] hover:text-black transition-colors ${fill ? "top-4 sm:top-6 w-9 h-9" : "bottom-4 sm:bottom-8 w-11 h-11"}`}>
        {muted ? <VolumeX className="w-5 h-5" /> : <Volume2 className="w-5 h-5" />}
      </button>
      {fill && (
        <button onClick={() => setZoomed((z) => !z)} data-testid="hero-fill-toggle" aria-label={zoomed ? "Fit video to screen" : "Fill the screen"}
          className="landscape:hidden absolute left-4 top-4 z-10 w-9 h-9 rounded-full bg-black/60 backdrop-blur border border-[#00d436]/50 text-lime flex items-center justify-center hover:bg-[#00d436] hover:text-black transition-colors">
          {zoomed ? <Minimize2 className="w-4 h-4" /> : <Maximize2 className="w-4 h-4" />}
        </button>
      )}
    </section>
  );
};
